module.exports = __webpack_public_path__ + "img/vcontroller-show-btn1-model.6c41c56a.jpg";